/**
 * State used in rendering TableSelectionCell
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
